<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>AJOUTER ADMIN</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="dataAvatar">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataAvatar" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Mise à jour Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataAvatar = null">Supprimer Image</vs-button>
          </div>
        </template>

        <!-- NAME -->
        <vs-input label="Nom" v-model="dataName" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>
        <!-- prenom -->
        <vs-input label="prenom" v-model="dataprenom" class="mt-5 w-full" name="item-prenom" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-prenom')">{{ errors.first('item-prenom') }}</span>
        <!-- email -->
        <vs-input label="email" v-model="dataemail" class="mt-5 w-full" name="item-email" v-validate="'required|email|min:3'" />
        <span class="text-danger text-sm" v-show="errors.has('item-email')">{{ errors.first('item-email') }}</span>
        <!-- adresse -->
        <vs-input label="adresse" v-model="dataadresse" class="mt-5 w-full" name="item-adresse" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-adresse')">{{ errors.first('item-adresse') }}</span>
        <!-- numero -->
        <vs-input label="mobile" v-model="datanumero" class="mt-5 w-full" name="item-numero" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-numero')">{{ errors.first('item-numero') }}</span>
        <!-- password -->
        <vs-input  label="mot de passe" type="password" v-model="datapassword" class="mt-5 w-full" name="item-password" v-validate="'required|min:6|max:10'" />
        <span class="text-danger text-sm" v-show="errors.has('item-password')">{{ errors.first('item-password') }}</span>
        <!-- password -->
        <ul class="centerx mt-5">
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="domaine">Domaine</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="formateur">Formateur</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="candidat">Candidat</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="formation">Formation</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="groupe">Groupe</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="depense">dépense</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="paiment">Paiment</vs-checkbox>
          </li>
          <li>
            <vs-checkbox v-model="checkBox1" vs-value="Emplois">Emplois de temps</vs-checkbox>
          </li>
          
        </ul>
        
        <div class="upload-img mt-5" v-if="!dataAvatar">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Télécharger image</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//import axios from "../../../http/axios/index.js"
import moduledomaine from '@/store/domaine/moduledomaine.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      console.log(this.data)
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { permisson,category, id, img, name, order_status, price } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataCategory = category
        this.dataAvatar = img
        this.dataName = name
        this.dataOrder_status = order_status
        this.dataPrice = price
        this.checkBox1 = permisson
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      checkBox1: [],
      file: null, 
      dataName: null, 
      dataprenom: null,
      dataemail: null,
      dataadresse: null,
      datanumero: null,
      datapassword: null,
      datadomaine: null,
      dataId: null,
      //dataName: "",
      dataCategory: null,
      dataAvatar: null,
      dataOrder_status: "pending",
      dataPrice: 0,

      category_choices: [],
      gradeData:'',
      grade_choices: [
        { label: 'Professeur', value: 'Professeur' },
        { label: 'Maître de conférences', value: 'Maître de conférences' },
        { label: 'Maître assistant', value: 'Maître assistant' },
        { label: 'Assistant', value: 'Assistant' },
        { label: 'Professeur technologue', value: 'Professeur technologue' },
        { label: 'Maître technologue', value: 'Maître technologue' },
        { label: 'Technologue', value: 'Technologue' },
        { label: 'Assistant technologue', value: 'Assistant technologue' },
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    domaineData() {
      return this.$store.state.domaine.users
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    domaine_choices() {
        let opts=[];
          for (var domaine of this.$store.state.domaine.users) {
              opts.push({label: domaine.nom_domaine, value: domaine.id});
              
            }
            console.log("1111111111111111111111111",this.$store.state.domaine.users)
            console.log("opts",opts)
      return opts
    },
    isFormValid() {
      return !this.errors.any() && this.dataName 
    }
  },
  methods: {
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataName = ""
        this.dataCategory = null
        this.dataOrder_status = "pending"
        this.dataPrice = 0
        this.dataAvatar = null
        //this.dataId = null
        //this.dataName = null
        this.checkBox1 = [],
        this.dataemail = null
        this.datagrade = null
        this.dataprenom = null
        this.dataadresse = null
        this.datanumero = null
        this.datapassword = null
        this.datadomaine = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          if (result) {
            const obj = {
              nom: this.dataName,
              avatar: this.dataAvatar,
              permission: JSON.stringify(this.checkBox1),
              email: this.dataemail,
              prenom: this.dataprenom,
              adresse: this.dataadresse,
              mobile: this.datanumero,
              password: this.datapassword,
            }
                  

                  console.log(obj)
                  console.log(this.dataAvatar)
            
          console.log(this.file)
              //this.$store.dispatch("formateur/addItem", obj).catch(err => { console.error(err) })
              this.$store.dispatch("candidat/addAdmin", obj).then(()   => { this.$store.dispatch("candidat/fetchAdmins").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'ajouter', 'ajouté avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas ajouter', 'une erreur: '+ err) })
              //this.$store.dispatch("user/addUser", obj).then(()   => { this.$store.dispatch("user/fetchUsers").catch(err => { console.error(err) }); this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
            

            this.$emit('closeSidebar')
            this.initValues()
            console.log(this.$store.state.formateur.users)
            //const image = this.file
            //axios.post('http://127.0.0.1:8000/api/addformateur',obj,image)
          }
      })
    console.log(this.dataName,this.dataemail,this.dataprenom,this.dataadresse,this.datanumero,this.datapassword,this.datadomaine)  
    console.log(this.$store.state.formateur.users)
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Admin '+title,
                text: 'La nouveau candidat '+text
              })
            },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataAvatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
         this.file = input.target.files[0]
        console.log(this.file)
      }
    }
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
  if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })


  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
